import { render, staticRenderFns } from "./Cantidades.vue?vue&type=template&id=15bea48f"
import script from "./Cantidades.vue?vue&type=script&lang=js"
export * from "./Cantidades.vue?vue&type=script&lang=js"
import style0 from "./Cantidades.vue?vue&type=style&index=0&id=15bea48f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports